import ProtectedRoute from "./components/auth/ProtectedRoute";
import AdminLayout from "./layouts/Admin";
import React from "react";

const xareGrowthProtectedRoutes = [
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"]}
        redirectToPath="/"
        path="/crm/dashboard"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"]}
        redirectToPath="/auth/login"
        path="/crm/settings"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/list"
        // requiredPermissionList={[AdminPermissionType.LIST_ADMIN]}
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/create"
        // requiredPermissionList={[AdminPermissionType.CREATE_ADMIN]}
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_ADMIN", "ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/show/:uniqueId"
        // requiredPermissionList={[AdminPermissionType.READ_ADMIN]}
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/edit/:uniqueId"
        // requiredPermissionList={[AdminPermissionType.UPDATE_ADMIN]}
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/company/list"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/company/create"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/company/show/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/company/edit/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3",]}
        redirectToPath="/"
        path="/crm/content/list"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN",]}
        redirectToPath="/"
        path="/crm/content/create"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/content/show/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3",]}
        redirectToPath="/"
        path="/crm/content/edit/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/contact/list"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/contact/create"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_TENANT_ADMIN","ROLE_SUPER_ADMIN","ROLE_LEVEL3", "ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/contact/show/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/contact/edit/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/meetingReport/createOld"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/meetingReport/create"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/meetingReport/list"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/meetingReport/edit/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/meetingReport/show/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/project/listOld"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/project/list"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/project/create"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/project/show/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/project/edit/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/nextSteps/list/"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/meetingReport/company/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/summary/"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/summary/:companyUid"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/projectSummaries/:projectUid"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/profile"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/event/list"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_SUPER_ADMIN","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/event/create"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_TENANT_ADMIN","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/event/show/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN","ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3","ROLE_STARTER","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/crm/event/edit/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN",]}
        redirectToPath="/"
        path="/crm/leads"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN","ROLE_TENANT_ADMIN"]}
        redirectToPath="/"
        path="/crm/lead/show/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"]}
        redirectToPath="/"
        path="/crm/drive/my-drive"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"]}
        redirectToPath="/"
        path="/crm/drive/my-drive/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"]}
        redirectToPath="/"
        path="/crm/drive/shared"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"]}
        redirectToPath="/"
        path="/crm/drive/shared/:uniqueId"
        component={(props) => <AdminLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"]}
        redirectToPath="/"
        path="/crm/drive/shared/:uniqueId/folder/:folderId"
        component={(props) => <AdminLayout {...props} />}
    />,
]

export default xareGrowthProtectedRoutes;